import * as signalR from "@microsoft/signalr";
import { HubConnectionState } from "@microsoft/signalr";

export const startChatHubConnection = async (sub: string, connection: signalR.HubConnection) => {
    if (connection.state !== HubConnectionState.Connected && connection.state !== HubConnectionState.Connecting) {
        try {
            await connection.start();
            connection.invoke("JoinGroups", sub);
        } catch (error) {
            console.log(error);
        }
    } else {
        console.log(connection.state);
    }
};

export const addMessageListener = (callback: (message: any) => void, connection: signalR.HubConnection) => {
    connection.on("ReceiveMessage", (message) => {
        callback(message);
    });
};

export const deleteMessageListener = (callback: () => void, connection: signalR.HubConnection) => {
    connection.on("DeleteMessage", () => {
        callback();
    });
}